import { useEffect, useRef, useState } from "react";
import { CalendarPlus } from "lucide-react";
import { googleCalUrl, downloadICS } from "../lib/calendar";

export function AddToCalendar({ event, dark = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const trigger = dark
    ? "text-[#C6FF33] hover:text-white"
    : "text-stone-500 hover:text-[#121212]";
  const item = dark
    ? "text-[#F2E9D8] hover:bg-white/10"
    : "text-[#121212] hover:bg-stone-100";
  const menuBg = dark ? "bg-[#1c1c1c] border-white/20" : "bg-white border-[#121212]";

  return (
    <div className="relative inline-block" ref={ref} onClick={stop}>
      <button
        data-testid={`addcal-${event.id}`}
        onClick={(e) => { stop(e); setOpen((o) => !o); }}
        className={`inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.05em] transition-colors ${trigger}`}
      >
        <CalendarPlus size={13} /> Add to calendar
      </button>
      {open && (
        <div className={`absolute left-0 bottom-full mb-2 z-30 w-48 border-2 shadow-xl ${menuBg}`}>
          <button
            data-testid={`addcal-google-${event.id}`}
            onClick={(e) => { stop(e); window.open(googleCalUrl(event), "_blank", "noopener"); setOpen(false); }}
            className={`block w-full text-left px-4 py-2.5 text-xs ${item}`}
          >
            Google Calendar
          </button>
          <button
            data-testid={`addcal-ics-${event.id}`}
            onClick={(e) => { stop(e); downloadICS(event); setOpen(false); }}
            className={`block w-full text-left px-4 py-2.5 text-xs border-t ${dark ? "border-white/15" : "border-stone-200"} ${item}`}
          >
            Apple / Outlook (.ics)
          </button>
        </div>
      )}
    </div>
  );
}
